<template>
  <div style="padding: 0 10px">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :key="0" :label="$t('trajectory.newOrderReturn')" name="first">
          <returnOld :sender-state-list="senderStateList" />
        </el-tab-pane>
        <el-tab-pane :key="1" :label="$t('trajectory.originalOrderReturnD2D')" name="second">
          <returnD2D :sender-state-list="senderStateList" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { selectState } from '@/api/orderApi';

export default {
  name: 'LogisticsOrder',
  components: {
    returnOld: () => import('./component/returnOld.vue'),
    returnD2D: () => import('./component/returnD2D.vue')
  },
  data() {
    return {
      activeName: 'first',
      isShow: true,
      isShow1: false,
      senderStateList: []
    };
  },
  created() {
    this.getState();
  },
  methods: {
    // 获取州
    getState(name = '') {
      // level 0 州    1 城市   2 地区
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.senderStateList = res.data.records;
        }
      });
    },
    handleClick(tab, event) {
      if (tab.name === 'first') {
        this.isShow1 = false;
        this.isShow = true;
      }
      if (tab.name === 'second') {
        this.isShow = false;
        this.isShow1 = true;
      }
    }
  }
};
</script>

<style scoped></style>
